import { colorConstants } from '../constant/color'


export default function color(state = {}, action) {
  switch (action.type) {

    case colorConstants.READ_COLORS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case colorConstants.READ_COLORS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case colorConstants.READ_COLORS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}